import Mock from 'mockjs'
import data from './data/list.json'

/* 工厂 */
Mock.mock('/echarts/board/plantTop10', 'get', (option) => {
  return {
    code: 200,
    data: [
      {
        name: '产线名称 F05',
        value: 221
      }, {
        name: '产线名称',
        value: 222
      }, {
        name: '产线名称',
        value: 223
      }, {
        name: '产线名称',
        value: 224
      }, {
        name: '产线名称',
        value: 225
      }, {
        name: '产线名称',
        value: 226
      }, {
        name: '产线名称',
        value: 227
      }, {
        name: '产线名称',
        value: 227
      }, {
        name: '产线名称',
        value: 227
      }, {
        name: '产线名称',
        value: 227
      }
    ],
    message: '成功'
  }
})

/* 产线 */
Mock.mock('/echarts/topHz', 'get', (option) => {
  return {
    code: 200,
    data: [
      {
        title: '产线名称',
        x: [
          {
            name: '工位1',
            value: 222
          },
          {
            name: '工位2',
            value: 212
          },
          {
            name: '工位3',
            value: 22
          },
          {
            name: '工位4',
            value: 22
          },
          {
            name: '工位5',
            value: 252
          },
          {
            name: '工位6',
            value: 226
          }
        ]
      },
      {
        title: '产线名称',
        x: [
          {
            name: '工位1',
            value: 222
          },
          {
            name: '工位2',
            value: 212
          },
          {
            name: '工位3',
            value: 22
          },
          {
            name: '工位4',
            value: 22
          },
          {
            name: '工位5',
            value: 252
          },
          {
            name: '工位6',
            value: 226
          }
        ]
      },
      {
        title: '产线名称',
        x: [
          {
            name: '工位1',
            value: 222
          },
          {
            name: '工位2',
            value: 212
          },
          {
            name: '工位3',
            value: 22
          },
          {
            name: '工位4',
            value: 22
          },
          {
            name: '工位5',
            value: 252
          },
          {
            name: '工位6',
            value: 226
          }
        ]
      },
      {
        title: '产线名称',
        x: [
          {
            name: '工位1',
            value: 222
          },
          {
            name: '工位2',
            value: 212
          },
          {
            name: '工位3',
            value: 22
          },
          {
            name: '工位4',
            value: 22
          },
          {
            name: '工位5',
            value: 252
          },
          {
            name: '工位6',
            value: 226
          }
        ]
      },
      {
        title: '产线名称',
        x: [
          {
            name: '工位1',
            value: 222
          },
          {
            name: '工位2',
            value: 212
          },
          {
            name: '工位3',
            value: 22
          },
          {
            name: '工位4',
            value: 22
          },
          {
            name: '工位5',
            value: 252
          },
          {
            name: '工位6',
            value: 226
          }
        ]
      },
      {
        title: '产线名称',
        x: [
          {
            name: '工位1',
            value: 222
          },
          {
            name: '工位2',
            value: 212
          },
          {
            name: '工位3',
            value: 22
          },
          {
            name: '工位4',
            value: 22
          },
          {
            name: '工位5',
            value: 252
          },
          {
            name: '工位6',
            value: 226
          }
        ]
      }
    ],
    message: '成功'
  }
})

/* 综合看板 */
// Mock.mock('/api/board/list', 'get', () => {
//   return data
// })
